export enum AlgoliaIndexId {
    SearchPage = 'search-page',
    BestSeller = 'best-seller',
    LastSeen = 'last-seen',
    ProductList = 'product-list',
    Attributes = 'attributes',
    RefinedAttribute = 'refined-attribute',
}
